import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addLink } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';

const useAddLink = () => {
    const entityUpdater = useEntityQueryUpdate();
    const queryClient = useQueryClient();

    const addLinkMutation = useMutation({
        mutationKey: 'add_link',
        mutationFn: (model) => addLink(model),
        onSuccess: (data) => {
            entityUpdater(
                [['campaign_links'], ['campaign_link', data.id]],
                data
            );
            queryClient.invalidateQueries({
                queryKey: ['link_group', data.groupId],
                exact: true,
            });
            notifications.show({
                title: 'Success',
                message: 'Successfully updated link',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return addLinkMutation;
};
export default useAddLink;
